import { all, fork } from "redux-saga/effects";

//public

import AuthSaga from "./auth/login/saga";

import forgetPasswordSaga from "./auth/forgetpwd/saga";
import Profile from "./auth/profile/saga";
import LayoutSaga from "./layout/saga";

import memberManagementSaga from "./SystemGeneral/MemberManagement/saga"
import pageManagementSaga from "./SystemGeneral/PageManagement/saga"
import roleManagementSaga from "./SystemGeneral/RoleManagement/saga"
import userManagementSaga from "./SystemGeneral/UserManagement/saga"
import userRoleRelationManagementSaga from "./SystemGeneral/UserRoleRelation/saga"
import endPointDefinitionManagementSaga from "./SystemGeneral/EndPointDefinition/saga"
import pageOperationManagementSaga from "./SystemGeneral/PageOperation/saga"
import userStatusDefSaga from "./SystemGeneral/UserStatusDef/saga"
import testManagementSaga from "./SystemGeneral/TestManagement/saga"
import dynamicPageManagementSaga from "./SystemGeneral/DynamicManagement/saga"
import commonFunctionsManagementSaga from "./SystemGeneral/CommonFunctionsManagement/saga"
import queryBuilderManagementSaga from "./QueryBuilder/saga";
import userAgreementManagementSaga from "./SystemGeneral/UserAgreementManagement/saga";

import merchantApplicationSaga from "./MerchantApplication/saga"
import countryManagementSaga from "./Country/saga";
import countryStateDefManagementSaga from "./CountryState/saga";
import cityDefManagementSaga from "./CityDef/saga";
import mccManagementSaga from "./Mcc/saga";
import districtDefinitionManagementSaga from "./District/saga";
import currencyManagementSaga from "./Currency/saga";
import companyTypeDefSaga from "./CompanyTypeDef/saga";
import paymentMethodDefManagementSaga from "./PaymentMethodDef/saga";
import applicationStatusDefManagementSaga from "./ApplicationStatusDef/saga";
import applicationSubStatusDefManagementSaga from "./ApplicationSubStatusDef/saga";
import merchantAgreementManagementSaga from "./MerchantAgreement/saga";
import documentTypeManagementSaga from "./DocumentType/saga";
import memoManagementSaga from "./MemoManagement/saga";
import transactionProvisionSettleSaga from "./TransactionProvisionSettle/saga";
import domesticBankDefinition from "./DomesticBank/saga";
import merchantPaymentFile from "./MerchantReconciliation/saga";
import chargebackMonitoring from "./ChargebackMonitoring/saga";

import payOutStatusDefSaga from "./PayOutStatusDef/saga";
import ravenTransactionTypeDefSaga from "./RavenTransactionTypeDef/saga";
import chargebackStatusDefSaga from "./ChargebackStatusDef/saga";
import transactionProvisionManagementSaga from "./TransactionProvision/saga";

import cardBrandDefSaga from "./CardBrandDef/saga";
import cardTypeDefSaga from "./CardTypeDef/saga";
import merchantPaymentDetailSaga from "./MerchantPaymentDetail/saga";
import posEntryModeSaga from "./PosEntryMode/saga";
import provisionStatusDefSaga from "./ProvisionStatusDef/saga";
import ravenAuthorizationResponseCodeDefSaga from "./RavenAuthorizationResponseCodeDef/saga";
import terminalDefSaga from "./TerminalDef/saga";
import transactionInstallmentTypeDefSaga from "./TransactionInstallmentTypeDef/saga";
import transactionNetworkDefSaga from "./TransactionNetworkDef/saga";
import transactionSourceDefSaga from "./TransactionSourceDef/saga";
import userPasswordManagement from "./SystemGeneral/UserPasswordManagement/saga"
import doPaymentSaga from "./DoPayment/saga";
import merchantCommissionList from "./MerchantCommissionList/saga"
import merchantPermissionSaga from "./MerchantPermission/saga";
import productTypeDefSaga from "./ProductTypeDef/saga";
import linkPaymentStatusDefSaga from "./LinkPaymentStatusDef/saga";
import merchantLinkPaymentManagementSaga from "./MerchantLinkPaymentDef/saga";
import installmentSaga from "./Installment/saga";
import hostedPaymentPageSaga from "./HostedPaymentPage/saga";

export default function* rootSaga() {
  yield all([
    //public
    fork(AuthSaga),
    fork(LayoutSaga),
    fork(Profile),
    fork(memberManagementSaga),
    fork(pageManagementSaga),
    fork(roleManagementSaga),
    fork(userManagementSaga),
    fork(userRoleRelationManagementSaga),
    fork(endPointDefinitionManagementSaga),
    fork(pageOperationManagementSaga),
    fork(userStatusDefSaga),
    fork(testManagementSaga),
    fork(forgetPasswordSaga),
    fork(dynamicPageManagementSaga),
    fork(commonFunctionsManagementSaga),
    fork(queryBuilderManagementSaga),
    fork(userAgreementManagementSaga),
    fork(merchantApplicationSaga),
    fork(countryManagementSaga),
    fork(countryStateDefManagementSaga),
    fork(cityDefManagementSaga),
    fork(mccManagementSaga),
    fork(districtDefinitionManagementSaga),
    fork(currencyManagementSaga),
    fork(companyTypeDefSaga),
    fork(paymentMethodDefManagementSaga),
    fork(applicationStatusDefManagementSaga),
    fork(applicationSubStatusDefManagementSaga),
    fork(merchantAgreementManagementSaga),
    fork(memoManagementSaga),
    fork(transactionProvisionSettleSaga),
    fork(domesticBankDefinition),
    fork(documentTypeManagementSaga),
    fork(merchantPaymentFile),
    fork(chargebackMonitoring),
    fork(payOutStatusDefSaga),
    fork(ravenTransactionTypeDefSaga),
    fork(chargebackStatusDefSaga),
    fork(transactionProvisionManagementSaga),
    fork(cardBrandDefSaga),
    fork(cardTypeDefSaga),
    fork(merchantPaymentDetailSaga),
    fork(posEntryModeSaga),
    fork(provisionStatusDefSaga),
    fork(ravenAuthorizationResponseCodeDefSaga),
    fork(terminalDefSaga),
    fork(transactionInstallmentTypeDefSaga),
    fork(transactionNetworkDefSaga),
    fork(transactionSourceDefSaga),
    fork(userPasswordManagement),
    fork(doPaymentSaga),
    fork(merchantCommissionList),
    fork(merchantPermissionSaga),
    fork(productTypeDefSaga),
    fork(linkPaymentStatusDefSaga),
    fork(merchantLinkPaymentManagementSaga),
    fork(installmentSaga),
    fork(hostedPaymentPageSaga),
  ]);
}
